import type { Idioma } from "./IdiomaProvider";

type Dicionario = Record<string, string>;

export const TEXTOS_DASHBOARD_VENDAS: Record<Idioma, Dicionario> = {
  pt: {
    "Dashboard de Vendas": "Dashboard de Vendas",
    "Dashboard de vendas": "Dashboard de vendas",
    "Visão geral das vendas, pedidos, faturamento e desempenho comercial.": "Visão geral das vendas, pedidos, faturamento e desempenho comercial.",
    "Não foi possível carregar o dashboard de vendas.": "Não foi possível carregar o dashboard de vendas.",
    "Nova Venda": "Nova Venda",
    "p.p.": "p.p.",
    "Faturamento Total": "Faturamento Total",
    "Pedidos no Período": "Pedidos no Período",
    "Ticket Médio": "Ticket Médio",
    "Taxa de Conversão": "Taxa de Conversão",
    "Vendas Concluídas": "Vendas Concluídas",
    Cancelamentos: "Cancelamentos",
    "Evolução das Vendas": "Evolução das Vendas",
    "Média do período anterior": "Média do período anterior",
    "Sem vendas no período.": "Sem vendas no período.",
    "Distribuição por Canal": "Distribuição por Canal",
    "Sem dados por canal.": "Sem dados por canal.",
    "Pedido de Cliente": "Pedido de Cliente",
    "Orçamento Convertido": "Orçamento Convertido",
    "Venda Direta": "Venda Direta",
    "Status dos Pedidos": "Status dos Pedidos",
    Pendentes: "Pendentes",
    "Em processamento": "Em processamento",
    Concluídos: "Concluídos",
    Cancelados: "Cancelados",
    "Total no período": "Total no período",
    "Atividade do dia": "Atividade do dia",
    "Novas vendas": "Novas vendas",
    "Vendas concluídas": "Vendas concluídas",
    "Vendas canceladas": "Vendas canceladas",
    "Clientes atendidos": "Clientes atendidos",
    "Ver relatório completo": "Ver relatório completo",
    "Categorias por Faturamento": "Categorias por Faturamento",
    "Sem categorias no período.": "Sem categorias no período.",
    "Pedidos Recentes": "Pedidos Recentes",
    "Nenhum pedido recente.": "Nenhum pedido recente.",
    "Ver todos os pedidos": "Ver todos os pedidos",
    "Top Vendedores": "Top Vendedores",
    "Vendas fechadas": "Vendas fechadas",
    "Sem vendedores no período.": "Sem vendedores no período.",
    "Ver ranking completo": "Ver ranking completo",
    "Desempenho por Canal": "Desempenho por Canal",
    Conversão: "Conversão",
    "Resumo Comercial": "Resumo Comercial",
    "Taxa de conclusão": "Taxa de conclusão",
    "Clientes recorrentes": "Clientes recorrentes",
    "Desconto médio": "Desconto médio",
    "Carregando dashboard de vendas.": "Carregando dashboard de vendas.",
    "Dashboard de vendas atualizado.": "Dashboard de vendas atualizado.",
  },
  en: {
    "Dashboard de Vendas": "Sales Dashboard",
    "Dashboard de vendas": "Sales dashboard",
    "Visão geral das vendas, pedidos, faturamento e desempenho comercial.": "Overview of sales, orders, revenue, and commercial performance.",
    "Não foi possível carregar o dashboard de vendas.": "The sales dashboard could not be loaded.",
    "Nova Venda": "New Sale",
    "p.p.": "pp",
    "Faturamento Total": "Total Revenue",
    "Pedidos no Período": "Orders in Period",
    "Ticket Médio": "Average Order Value",
    "Taxa de Conversão": "Conversion Rate",
    "Vendas Concluídas": "Completed Sales",
    Cancelamentos: "Cancellations",
    "Evolução das Vendas": "Sales Trend",
    "Média do período anterior": "Previous period average",
    "Sem vendas no período.": "No sales in this period.",
    "Distribuição por Canal": "Distribution by Channel",
    "Sem dados por canal.": "No channel data.",
    "Pedido de Cliente": "Customer Order",
    "Orçamento Convertido": "Converted Quote",
    "Venda Direta": "Direct Sale",
    "Status dos Pedidos": "Order Status",
    Pendentes: "Pending",
    "Em processamento": "Processing",
    Concluídos: "Completed",
    Cancelados: "Cancelled",
    "Total no período": "Total in period",
    "Atividade do dia": "Today's Activity",
    "Novas vendas": "New sales",
    "Vendas concluídas": "Completed sales",
    "Vendas canceladas": "Cancelled sales",
    "Clientes atendidos": "Customers served",
    "Ver relatório completo": "View full report",
    "Categorias por Faturamento": "Categories by Revenue",
    "Sem categorias no período.": "No categories in this period.",
    "Pedidos Recentes": "Recent Orders",
    "Nenhum pedido recente.": "No recent orders.",
    "Ver todos os pedidos": "View all orders",
    "Top Vendedores": "Top Salespeople",
    "Vendas fechadas": "Closed sales",
    "Sem vendedores no período.": "No salespeople in this period.",
    "Ver ranking completo": "View full ranking",
    "Desempenho por Canal": "Performance by Channel",
    Conversão: "Conversion",
    "Resumo Comercial": "Commercial Summary",
    "Taxa de conclusão": "Completion rate",
    "Clientes recorrentes": "Returning customers",
    "Desconto médio": "Average discount",
    "Carregando dashboard de vendas.": "Loading sales dashboard.",
    "Dashboard de vendas atualizado.": "Sales dashboard updated.",
  },
  es: {
    "Dashboard de Vendas": "Panel de Ventas",
    "Dashboard de vendas": "Panel de ventas",
    "Visão geral das vendas, pedidos, faturamento e desempenho comercial.": "Resumen de ventas, pedidos, facturación y rendimiento comercial.",
    "Não foi possível carregar o dashboard de vendas.": "No se pudo cargar el panel de ventas.",
    "Nova Venda": "Nueva Venta",
    "p.p.": "p.p.",
    "Faturamento Total": "Facturación Total",
    "Pedidos no Período": "Pedidos del Período",
    "Ticket Médio": "Ticket Promedio",
    "Taxa de Conversão": "Tasa de Conversión",
    "Vendas Concluídas": "Ventas Completadas",
    Cancelamentos: "Cancelaciones",
    "Evolução das Vendas": "Evolución de las Ventas",
    "Média do período anterior": "Promedio del período anterior",
    "Sem vendas no período.": "No hay ventas en el período.",
    "Distribuição por Canal": "Distribución por Canal",
    "Sem dados por canal.": "No hay datos por canal.",
    "Pedido de Cliente": "Pedido de Cliente",
    "Orçamento Convertido": "Presupuesto Convertido",
    "Venda Direta": "Venta Directa",
    "Status dos Pedidos": "Estado de los Pedidos",
    Pendentes: "Pendientes",
    "Em processamento": "En proceso",
    Concluídos: "Completados",
    Cancelados: "Cancelados",
    "Total no período": "Total del período",
    "Atividade do dia": "Actividad del día",
    "Novas vendas": "Nuevas ventas",
    "Vendas concluídas": "Ventas completadas",
    "Vendas canceladas": "Ventas canceladas",
    "Clientes atendidos": "Clientes atendidos",
    "Ver relatório completo": "Ver informe completo",
    "Categorias por Faturamento": "Categorías por Facturación",
    "Sem categorias no período.": "No hay categorías en el período.",
    "Pedidos Recentes": "Pedidos Recientes",
    "Nenhum pedido recente.": "No hay pedidos recientes.",
    "Ver todos os pedidos": "Ver todos los pedidos",
    "Top Vendedores": "Mejores Vendedores",
    "Vendas fechadas": "Ventas cerradas",
    "Sem vendedores no período.": "No hay vendedores en el período.",
    "Ver ranking completo": "Ver clasificación completa",
    "Desempenho por Canal": "Rendimiento por Canal",
    Conversão: "Conversión",
    "Resumo Comercial": "Resumen Comercial",
    "Taxa de conclusão": "Tasa de finalización",
    "Clientes recorrentes": "Clientes recurrentes",
    "Desconto médio": "Descuento promedio",
    "Carregando dashboard de vendas.": "Cargando el panel de ventas.",
    "Dashboard de vendas atualizado.": "Panel de ventas actualizado.",
  },
  "zh-CN": {
    "Dashboard de Vendas": "销售仪表板",
    "Dashboard de vendas": "销售仪表板",
    "Visão geral das vendas, pedidos, faturamento e desempenho comercial.": "查看销售、订单、营收和商业绩效概览。",
    "Não foi possível carregar o dashboard de vendas.": "无法加载销售仪表板。",
    "Nova Venda": "新建销售",
    "p.p.": "个百分点",
    "Faturamento Total": "总营收",
    "Pedidos no Período": "期间订单",
    "Ticket Médio": "平均客单价",
    "Taxa de Conversão": "转化率",
    "Vendas Concluídas": "已完成销售",
    Cancelamentos: "取消数",
    "Evolução das Vendas": "销售趋势",
    "Média do período anterior": "上一周期平均值",
    "Sem vendas no período.": "该期间没有销售。",
    "Distribuição por Canal": "按渠道分布",
    "Sem dados por canal.": "没有渠道数据。",
    "Pedido de Cliente": "客户订单",
    "Orçamento Convertido": "已转化报价",
    "Venda Direta": "直接销售",
    "Status dos Pedidos": "订单状态",
    Pendentes: "待处理",
    "Em processamento": "处理中",
    Concluídos: "已完成",
    Cancelados: "已取消",
    "Total no período": "期间总计",
    "Atividade do dia": "今日动态",
    "Novas vendas": "新增销售",
    "Vendas concluídas": "已完成销售",
    "Vendas canceladas": "已取消销售",
    "Clientes atendidos": "服务客户数",
    "Ver relatório completo": "查看完整报告",
    "Categorias por Faturamento": "按营收分类",
    "Sem categorias no período.": "该期间没有分类数据。",
    "Pedidos Recentes": "近期订单",
    "Nenhum pedido recente.": "没有近期订单。",
    "Ver todos os pedidos": "查看所有订单",
    "Top Vendedores": "销售人员排行",
    "Vendas fechadas": "成交销售",
    "Sem vendedores no período.": "该期间没有销售人员数据。",
    "Ver ranking completo": "查看完整排名",
    "Desempenho por Canal": "按渠道绩效",
    Conversão: "转化率",
    "Resumo Comercial": "商业摘要",
    "Taxa de conclusão": "完成率",
    "Clientes recorrentes": "回头客",
    "Desconto médio": "平均折扣",
    "Carregando dashboard de vendas.": "正在加载销售仪表板。",
    "Dashboard de vendas atualizado.": "销售仪表板已更新。",
  },
};
